import React, { useRef } from "react";
import { OutlinedInput, ButtonBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import { inputHeight } from '../theme';

interface SearchBoxProps {
  placeholder?: string;
  term?: string;
  handleChange?: (...args: any[]) => void;
  handleKeyUp?: (...args: any[]) => void;
  onEnter?: (...args: any[]) => void;
  inputStyle?: React.CSSProperties;
  [key: string]: any;
}

const SearchContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto'
  }
}));

const SearchIconDiv = styled('div')(({ theme }) => ({
  width: `calc(${theme.spacing(7)} - 1px)`,
  height: '100%',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  top: 0,
  color: '#737373'
}));

const SearchIconButton = styled(ButtonBase)({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: '0 6px 6px 0'
});

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  height: inputHeight,
  '& .MuiOutlinedInput-notchedOutline': {
    top: 0,
    '& legend': {
      display: 'none'
    }
  },
  '& .MuiOutlinedInput-input': {
    paddingTop: theme.spacing(),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(),
    paddingRight: theme.spacing(7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '10em',
      '&:focus': {
        width: '14em'
      }
    }
  }
}));

const SearchBox = (props: SearchBoxProps) => {
  const { placeholder, term, handleChange, handleKeyUp, onEnter, inputStyle } = props;
  const input = useRef<HTMLInputElement>(null);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter(e);
      e.preventDefault();
    }
  };

  const handleKeyUpInternal = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (handleKeyUp) {
      handleKeyUp(e);
    }
  };

  return (
    <SearchContainer>
      <StyledOutlinedInput
        notched={false}
        placeholder={placeholder}
        value={term}
        inputProps={{ onKeyPress: handleKeyPress, onKeyUp: handleKeyUpInternal, onChange: handleChange, ref: input, style: inputStyle }}
      />
      <SearchIconDiv>
        <SearchIconButton onClick={() => onEnter({ currentTarget: input.current })}><SearchIcon /></SearchIconButton>
      </SearchIconDiv>
    </SearchContainer>);
};

export default SearchBox;
